module.exports = __webpack_public_path__ + "static/media/aspect-ratio.c5bb0ac5.svg";